export const getAlertManagementState = state => state.alertManagement.data;
export const getAlertManagementLoading = state =>
  state.alertManagement.loading.global ||
  state.alertManagement.loading.specific;
